module.exports = __webpack_public_path__ + "img/seatselection_cubstickets.81f5ac57.svg";